import { render } from "./CargaArchivo.vue?vue&type=template&id=6f4a5aca"
import script from "./CargaArchivo.vue?vue&type=script&lang=js"
export * from "./CargaArchivo.vue?vue&type=script&lang=js"

import "./CargaArchivo.vue?vue&type=style&index=0&id=6f4a5aca&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__